import { useState } from "react"
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ResponsiveFooter from "../ResponsiveFooter";

import { Card, CardContent, Grid, TextField, Button } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import * as React from 'react';

import * as constants from "../constants.js"


const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [isEmailValid, setEmailValid] = useState(false);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('info');
    const navigate = useNavigate();

    const cardStyle = {
      borderRadius: '10px', // Adjust the value to control the roundness of the corners
      // You can also add other styles like backgroundColor, boxShadow, etc.
    };

    const isValidEmail = (validEmail) => {
        // You can use a regular expression or a more robust email validation method here
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(validEmail);
    };

    const handleEmailChangeInput = (e) => {
        setEmail(e.target.value)
        setEmailValid(true);
        if (!isValidEmail(email)) {
            setEmailValid(false);
            return;
        }
    };

    const handleSnackbarClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    };

    const handleEmailChangeSubmit = async (e) => {
        e.preventDefault()
        try{
          const resp = await axios.create({
              withCredentials: true,
          }).post("//" + constants.BASE_URL + "/forgot_password", {
            email
          });
          setMessage(resp.data.success);
          setSeverity('success');
          setOpen(true);
        }
        catch(error){
            if (error.response) {
              setMessage(error.response.data.error);
            } else if (error.request) {
              setMessage('The request was made but no response was received');
            } else {
              setMessage('An error occurred');
            }
            setSeverity('error');
            setOpen(true);
        }
    };

     
    return ( 
        <div className="home">
            <div className="body-content">
              <br></br>
              <br></br>
              <h2>Neues Passwort generieren</h2>
              <br></br>

          <Card style={cardStyle}>
            <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="E-mail"
              variant="outlined"
              fullWidth
              value={email}
              onChange={handleEmailChangeInput}
              error={!isEmailValid}
              helperText={!isEmailValid && "Die angegebene E-mail ist nicht zulässig."}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleEmailChangeSubmit}
              disabled={!isEmailValid}
            >
              Neues Passwort generieren
            </Button>
          </Grid>
        </Grid>
            </CardContent>
          </Card>
          <br></br>
          <Button
              variant="contained"
              color="grey"
              onClick={() => {navigate('/login');}}
            >
              Zum Login
            </Button>

            <Snackbar open={open} autoHideDuration={6000} onClose={handleSnackbarClose}>
              <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity={severity}>
                {message}
              </MuiAlert>
            </Snackbar>

          </div>
          <ResponsiveFooter />
        </div>
     );
}
 
export default ForgotPassword;